module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai_hiratsuka/btn/btn_on-3181af5b98e688780ae587459b0be658.jpg";